import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="border-t border-gray-100 bg-white py-8 mt-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center text-sm text-gray-500">
        <p className="font-semibold text-navy-800 mb-1">{t('app.name')} — {t('app.tagline')}</p>
        <p>© {new Date().getFullYear()} FormMitra. All rights reserved.</p>
        <p className="mt-2 text-xs">
          ⚠️ We only fill the form. Final submission must be done on the official government site.
        </p>
      </div>
    </footer>
  );
}
